/** A stretch along one axis, in px: where it starts and where it ends. */
export interface Span {
  start: number;
  end: number;
}

/**
 * How far a sideways-scrolling strip (Settings' tabs on a phone) should be
 * scrolled so one of its items shows whole, with `margin` px to spare at the
 * strip's edge: where it is when the item is in view already (so nothing
 * moves), else just far enough. An item wider than the strip lines up with
 * its start. The browser clamps the result to what the strip can scroll.
 *
 * @param item - The item, measured from the start of the strip's content.
 * @param scrollLeft - How far the strip is scrolled now.
 * @param width - The strip's visible width.
 * @param margin - The room to keep between the item and the strip's edge.
 */
export function revealScrollLeft(
  item: Span,
  scrollLeft: number,
  width: number,
  margin = 0,
): number {
  const viewStart = scrollLeft + margin;
  const viewEnd = scrollLeft + width - margin;
  if (item.start >= viewStart && item.end <= viewEnd) {
    return scrollLeft;
  }
  const fits = item.end - item.start <= width - 2 * margin;
  if (!fits || item.start < viewStart) {
    return Math.max(0, item.start - margin);
  }
  return item.end - width + margin;
}
